import tmpl from './manage.phtml';
import View from 'lib/View';

export default View.extend({
	template: tmpl,

	events: {
		'submit form': 'onSubmit',
		'keyup textarea': 'removeInvalidFeedback',
		'focus textarea': 'scrollToEventTarget',
		'change :input': 'removeInvalidFeedback',
		'render': 'scrollToInvalidFeedback',
	},


	onSubmit: function( evt )
	{
		evt.preventDefault();

		// Récupération des données
		var data = this.$('form').serializeJSON();
		this.$(':input, button').prop('disabled',true);

		// Validation locale
		this.model.set( data );
		if( !this.model.isValid() )
		{
			return this.render();
		}

		// Sauvegarde en local
		this.model.set('todo','update');
		app.commit();

		app.redirect('user/account');
	},




	render: function()
	{
		this.doRender({
			user: this.model,
			data: app.getStore('data')
		});
	}

});
